@if (tableMode) {
    <ng-container [ngTemplateOutlet]="tableForm"></ng-container>
} @else {
    <h4 class="label">{{ props.label }}</h4>
    @if (props.description) {
        <p class="description text-subtle">{{ props.description }}</p>
    }
    @for (group of formArray.controls; track group; let i = $index) {
        <div class="outer-form__wrapper">
            <div class="inner-form__wrapper">
                <formly-form [fields]="fields[i]" (modelChange)="group.patchValue($event)"></formly-form>
                <mat-divider [vertical]="true"></mat-divider>
                <div class="inner-form__toolbar">
                    <p class="toolbar__counter text-subtle">{{ i + 1 }}/{{ formArray.length }}</p>
                    <div class="spacer"></div>
                    <button color="error" mat-icon-button (click)="removeItem(i)">
                        <mat-icon>close</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    }
    <div class="add-item__wrapper">
        <button color="primary" mat-button (click)="addItem()">ADD ITEM</button>
    </div>
}

<ng-template #tableForm>
    <ag-grid-angular
        #formArrayGrid
        [theme]="comfortableTheme"
        [style.height.px]="500"
        [gridOptions]="gridOptions"
        [columnDefs]="columnDefs"
        [rowData]="rows"
        (rowDataUpdated)="onRowsUpdated($event)"
        (cellValueChanged)="onCellValueChanged($event)"
        [pinnedTopRowData]="pinnedTopRowData"
    ></ag-grid-angular>
</ng-template>
